/**
 * /frontend/src/features/analytics/components/anomalies/AnomalyAlertBanner.js
 */

import React from 'react';
import './AnomalyAlertBanner.css';

const severityClass = (severity) => (String(severity || '').toUpperCase() === 'CRITICAL' ? 'critical' : 'warning');

/**
 * Shows active anomalies banner.
 * @param {{items:Array<any>}} props
 * @returns {JSX.Element|null}
 */
const AnomalyAlertBanner = ({ items }) => {
  const rows = items || [];
  if (rows.length === 0) return null;

  return (
    <div className="analytics-anomaly-banner" role="status">
      {rows.slice(0, 3).map((item) => (
        <div key={`${item.type}-${item.triggeredAt}`} className={`analytics-anomaly-pill ${severityClass(item.severity)}`}>
          <span className="analytics-anomaly-type">{item.type}</span>
          <span className="analytics-anomaly-meta">{item.affectedEntity || 'Store'}</span>
        </div>
      ))}
      {rows.length > 3 ? <div className="analytics-anomaly-more">+{rows.length - 3} more</div> : null}
    </div>
  );
};

export default AnomalyAlertBanner;

